<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" style="margin:10px 0px 0px 10px" size="small" label-width="100px">
					<el-form-item>
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" row-key="id">
					<el-table-column prop="id" label="序号" width="60">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column prop="title" label="轮播图名称"></el-table-column>
					<el-table-column prop="url" label="图片">
						<template slot-scope="scope">
							<el-image style="width: 50px; height: 50px" :src="scope.row.url" fit="fit" :preview-src-list="[scope.row.url]"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="state" label="是否开启" width="80px">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.stateSw" @change="statusSwChange(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="180">
						<template slot-scope="scope">
							<el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
							<el-button :disabled="scope.$index === 0" @click="handleUp(scope.$index)" size="mini" type="text">上移</el-button>
							<el-button :disabled="scope.$index === datas.length - 1" @click="handleDown(scope.$index)" size="mini" type="text">下移</el-button>
							<el-button size="mini" @click="handleDelete(scope.row)" type="text">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="轮播图名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title"></el-input></el-form-item>
				<el-form-item label="图片地址" prop="url">
					<el-upload class="avatar-uploader" drag action="/api/system/file/upload" :multiple="false" :headers="headers" :show-file-list="false"
						:on-success="handleUploadSuccess">
						<img v-if="addOrUpdateForm.url" :src="addOrUpdateForm.url" style="width:100%" class="avatar">
						<div v-else>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						</div>
					</el-upload>
					<div style="color:red;margin-top:-15px">图片大小不能超过2M、比例2:1</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'mngr/institution/scroll/img',
				name: '轮播图',
				headers: {},
				queryParams: {
					currentPage: 1,
					pageSize: 100,
				},
				rules: {
					title: [{
							required: true,
							message: '请输入轮播图名称',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度最长支持100',
							trigger: 'blur'
						}
					],
					url: [{
						required: true,
						message: '请选择图片地址',
						trigger: 'blur'
					}]
				},
				tableKey: Date.now()
			};
		},
		filters: {},
		methods: {
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
				} else {
					this.addOrUpdateForm = {};
				}
			},
			beforeUpdate() {},
			handleUploadSuccess(res, file) {
				this.addOrUpdateForm.url = res.data;
				this.$forceUpdate();
			},
			handleUp(index) { //图片往前移动
				this.swapItems(this.datas, index, index - 1)
			},
			handleDown(index) { //图片往后移动
				this.swapItems(this.datas, index, index + 1)
			},
			swapItems(arr, index1, index2) {
				var newArr = JSON.parse(JSON.stringify(arr));
				newArr[index1] = newArr.splice(index2, 1, newArr[index1])[0]
				var request = []
				newArr.forEach((item, i) => {
					request.push({
						id:item.id,
						orderBy:i+1
					})
				});
				this.$http({
					method: 'POST',
					url: '/mngr/institution/scroll/img/updateOrder',
					data:request,
				}).then((res)=> {
					this.datas = newArr;
				})
			}
		},
		mounted: function() {
			let token = sessionStorage.getItem('token');
			this.headers.Token = token;
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/operation/institutionScrollImg.vue